import { ReactNode } from 'react'
import classNames from 'classnames/bind'

import isProduction from 'app/common/lib/isProduction'

import styles from './plain-fieldset.module.scss'

const cx = classNames.bind(styles)

export type FieldsetProps = {
  children: ReactNode
  className?: string
  id?: string
  legend?: ReactNode
  hideLegend?: boolean
  name?: string
  ariaLabelledby?: string
  legendClassName?: string
  skipUpperSpace?: boolean
  skipVerticalSpaces?: boolean
  strong?: boolean
  border?: boolean
  error?: boolean
}

const PlainFieldset = ({
  children,
  className,
  id,
  legend,
  hideLegend,
  name,
  ariaLabelledby,
  legendClassName,
  skipUpperSpace,
  skipVerticalSpaces,
  strong,
  border,
  error,
}: FieldsetProps) => {
  if (!isProduction() && !legend && !ariaLabelledby) {
    console.error('Не указан один из обязательных параметров `legend` или `ariaLabelledby`')
  }

  return (
    <fieldset
      id={id}
      className={cx(styles.root, { skipUpperSpace, border, skipVerticalSpaces, error }, className)}
      name={name}
      aria-labelledby={ariaLabelledby}
    >
      {legend && (
        <legend className={cx(styles.legend, { strong, hideLegend }, legendClassName)}>
          {legend}
        </legend>
      )}
      {children}
    </fieldset>
  )
}

export default PlainFieldset
